export default __webpack_public_path__ + "static/media/Kannada_af_1.13449611.mp3";